import React, { useEffect } from 'react';
import Header from './header/header.jsx';
import Footer from './footer/footer.jsx';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  useEffect(() => {
    document.body.classList.add('theme-gold');
    return () => {
      document.body.classList.remove('theme-gold');
    };
  }, []);
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
